const upCode = 38;
const downCode = 40;
const leftCode = 37;
const rightCode = 39;
const enterCode = 13;
const spaceCode = 32;
const pageDownCode = 34;
const homeCode = 36;
const endCode = 35;
const escapeCode = 27;

const rightCodes = ['Right', 'ArrowRight', rightCode];
const leftCodes = ['Left', 'ArrowLeft', leftCode];
const upCodes = ['Up', 'ArrowUp', upCode];
const downCodes  = ['Down', 'ArrowDown', downCode];
const enterCodes  = ['Enter', enterCode];
const spaceCodes  = [' ', 'Spacebar', spaceCode];
const pageDownCodes  = ['Down', 'PageDown', pageDownCode];
const homeCodes  = ['Home', homeCode];
const endCodes  = ['End', endCode];
const escapeCodes = ['Escape', 'Esc', escapeCode];

module.exports = {
    rightCodes,
    leftCodes,
    upCodes,
    downCodes,
    enterCodes,
    spaceCodes,
    pageDownCodes,
    homeCodes,
    endCodes,
    escapeCodes
};



// WEBPACK FOOTER //
// /node_modules/@mands/mns-fe-pattern-library/lib/mns-fe-utilities/keyCodes/index.js